import Vue from 'vue'
import EventBus from '../../../../utils/event-bus'
import { memorize } from '@spartancode/memorize'
import { isObject } from '../../../../utils'
import { isNil } from 'lodash'

/**
 * @description kifejezes kiertekelese a szerveren majd az eredemny memoize cachbe torteno tarolasa
 * @type {Readonly<{process: function(): Promise<*>, clear: function(): void}>}
 */
const execEval = memorize(async function (parameters) {
  try {
    let request = await Vue.prototype.$client.execute({
      operationId: 'Dynform_expressionEval',
      parameters,
    })
    return request.body
  } catch (e) {
    EventBus.$emit('showExpNotification', {
      group: 'basic-notification',
      text: 'calculation_server_error',
      title: 'calculation_error',
      type: 'error',
    })

    console.error('error in request: %o', e.message)
    return ''
  }
})

/**
 * @description query param cache-ek törlése memoize-ból
 */
export function clearEvalCache() {
  return execEval.clear()
}

/**
 * @description a state-ben felepitjuk a Query lekerdezeseket
 * @param state
 * @param rootState
 */
export async function prepareQueries({ state, rootState }) {
  const queries = {}

  ;[...state.form.queryExpressions].forEach(({ name, prop }) => {
    if (!queries[name]) {
      queries[name] = []
    }

    if (!queries[name].includes(prop) && prop.length) {
      queries[name].push(prop)
    }
  })

  await Promise.all(Object.keys(queries).map((name) => generateQueryFunctions(name, queries[name], rootState)))
}

/**
 *
 * @param name
 * @param columns
 * @param parent
 */
export async function generateQueryFunctions(name, columns, parent) {
  if (!parent.Queries[name]) {
    parent.Queries[name] = {}
  }

  parent.Queries[name] = async function () {
    const args = arguments
    let ret = {}

    if (columns.length) {
      const resultType = getResultType(columns)
      columns.forEach((column) => {
        ret[column] = (async function () {
          let argsToPass = []
          ;[...args].forEach((arg) => {
            if (isNil(arg) || isObject(arg)) {
              arg = ''
            }

            try {
              argsToPass.push(arg)
            } catch (e) {
              console.error('error in parameter evaluation: %o', e.message)
            }
          })

          const parameters = {
            name,
            column: resultType,
            params: JSON.stringify(argsToPass),
          }
          try {
            const res = await execEval.process(parameters)
            return res[column]
          } catch (e) {
            return ''
          }
        })()
      })
    } else {
      let argsToPass = []
      ;[...args].forEach((arg) => {
        if (isNil(arg) || isObject(arg)) {
          arg = ''
        }

        try {
          argsToPass.push(arg)
        } catch (e) {
          console.error('error in parameter evaluation: %o', e.message)
        }
      })

      const parameters = {
        name,
        column: '',
        params: JSON.stringify(argsToPass),
      }
      ret = await execEval.process(parameters)
    }
    return ret
  }
}

/**
 *
 * @param columns
 * @return {string}
 */
function getResultType(columns) {
  if (columns.length === 1 && columns[0] === 'FULL_RESULT') {
    return 'FULL_RESULT'
  }
  return '*'
}
